export enum ActionTypes {
    FETCH_LOCATIONS = "locations-module/fetch-locations",
    CREATE_LOCATION = "locations-module/create-location",
    UPDATE_LOCATION = "locations-module/update-location",
    DELETE_LOCATION = "locations-module/remove-location"
}
